import { NavLink, Outlet } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext";
import { StudentGeneralInformationView } from "../../../models/views/identity/StudentGeneralInformationView ";
import StudentService from "../../../services/student/StudentService";
import AuthenticatedComponent from "../../base/AuthenticatedComponent/AuthenticatedComponent";
import ContactUsLink from "../../shared/contact-us/ContactUs";

export default class EmptyLayout extends AuthenticatedComponent<{}, { userInformation: StudentGeneralInformationView }> {
    studentService: StudentService;
    constructor(props: any) {
        super(props);
        this.state = {
            userInformation: {
                education: {},
                personal: {},
                system: {},
            }
        };
        this.studentService = new StudentService();
    }

    componentDidMount = () => {
        let self = this;
        self.studentService.getStudentInformation().then(function (response) {
            if (response.status === 200)
                self.setState({ userInformation: response.data });
        });
    }

    render = () => {
        return (
            <>
                <div className="page default-layout-area">
                    <div className="main">
                        <div className="header " style={{height:2}}>
                        </div>
                        <div className=" px-4">
                            <AuthContext.Provider value={{ isAuthenticated: false, userInformation: this.state.userInformation, hasContactUs: true, pageUri: '' }}>
                                <ContactUsLink/>
                                <Outlet />
                            </AuthContext.Provider>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}